import { render, staticRenderFns } from "./CuringHistory.vue?vue&type=template&id=487185e2&scoped=true&"
import script from "./CuringHistory.vue?vue&type=script&lang=js&"
export * from "./CuringHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487185e2",
  null
  
)

export default component.exports